import React from 'react';
import { sizes } from '@sharefiledev/antd-config';
import { CheckCircle, TextFields, UserFeedback, Users } from '@sharefiledev/icons';
import { Col, Flex, Row, StepProps, Steps, Typography } from 'antd';
import { useGetScreenSize } from '../../common/hooks/useGetScreenSize';
import { useAppStore } from '../../common/store';
import { ICON_SIZE } from '../../constants';
import { t } from '../../utils/translate';

const { Title } = Typography;

export const Header = () => {
	const { isSmallScreen, isExtraSmallScreen } = useGetScreenSize();

	const { templateMetadata, documentTemplate } = useAppStore(state => ({
		templateMetadata: state.templateMetadata,
		documentTemplate: state.documentTemplate,
	}));

	const showTitle = !isSmallScreen && !isExtraSmallScreen;

	const getTitle = (title: string) => {
		return showTitle && { title };
	};

	const steps: StepProps[] = [
		{
			...getTitle(t('header.stepper.stepOne')),
			status:
				templateMetadata?.currentStep === 1 || templateMetadata?.currentStep === 2
					? 'finish'
					: 'process',
			icon:
				templateMetadata?.currentStep === 1 || templateMetadata?.currentStep === 2 ? (
					<CheckCircle size={ICON_SIZE} />
				) : (
					<Users size={ICON_SIZE} />
				),
		},
		{
			...getTitle(t('header.stepper.stepTwo')),
			status:
				templateMetadata?.currentStep === 1
					? 'process'
					: templateMetadata?.currentStep === 2
					? 'finish'
					: 'wait',
			icon:
				templateMetadata?.currentStep === 2 ? (
					<CheckCircle size={ICON_SIZE} />
				) : (
					<TextFields size={ICON_SIZE} />
				),
		},
		{
			...getTitle(t('header.stepper.stepThree')),
			status: templateMetadata?.currentStep === 2 ? 'process' : 'wait',
			icon: <UserFeedback size={ICON_SIZE} />,
		},
	];

	let style = {};

	if (isSmallScreen) {
		style = { fontSize: sizes.base };
	} else if (isExtraSmallScreen) {
		style = { fontSize: sizes.SM };
	}

	const columnSpans = {
		titleSpan: isExtraSmallScreen || isSmallScreen ? 8 : 6,
		stepperSpan: 12,
	};

	return (
		<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} align="middle">
			<Col span={columnSpans.titleSpan}>
				<Flex>
					<Title level={4} style={style}>
						{t('header.title')}
					</Title>
				</Flex>
			</Col>
			{documentTemplate && !isNaN(templateMetadata?.currentStep) && (
				<Col span={columnSpans.stepperSpan}>
					<Steps
						items={steps}
						size="small"
						data-testid="header-stepper"
						responsive={false}
					/>
				</Col>
			)}
		</Row>
	);
};
